<template>
  <div class="pricing-page">
    <!-- Hero Section -->
    <section class="pricing-hero bg-primary text-white py-5">
      <div class="container text-center">
        <h1 class="display-4 fw-bold mb-3">Soluzioni su Misura</h1>
        <p class="lead mb-0">Software gestionale specializzato per il mercato FVG</p>
      </div>
    </section>

    <!-- Pricing Cards -->
    <section class="pricing-cards py-6">
      <div class="container">
        <!-- Toggle Piano Base/Esteso -->
        <div class="text-center mb-3">
          <div class="btn-group">
            <button
              :class="['btn', isBasePlan ? 'btn-primary' : 'btn-outline-primary']"
              @click="isBasePlan = true"
            >
              Piano Base (50 utenti)
            </button>
            <button
              :class="['btn', !isBasePlan ? 'btn-primary' : 'btn-outline-primary']"
              @click="isBasePlan = false"
            >
              Piano Esteso (75 utenti)
            </button>
          </div>
        </div>

        <!-- Toggle Abbonamento/Perpetua -->
        <div class="text-center mb-5">
          <div class="btn-group">
            <button
              :class="['btn', isSubscription ? 'btn-primary' : 'btn-outline-primary']"
              @click="isSubscription = true"
            >
              Abbonamento Mensile
            </button>
            <button
              :class="['btn', !isSubscription ? 'btn-primary' : 'btn-outline-primary']"
              @click="isSubscription = false"
            >
              Licenza Perpetua
            </button>
          </div>
        </div>

        <div class="row g-4">
          <!-- Auto FVG -->
          <div class="col-md-4">
            <div class="card h-100 shadow-sm">
              <div class="card-body">
                <div class="text-center mb-4">
                  <div class="feature-icon bg-primary bg-gradient mb-3">
                    <i class="bi bi-car-front fs-2"></i>
                  </div>
                  <h2 class="card-title">Auto FVG</h2>
                  <p class="text-muted">1 Azienda</p>
                  <div class="pricing mt-3">
                    <h3 class="display-6 fw-bold">
                      {{ getPriceDisplay('auto') }}
                    </h3>
                    <p class="text-muted">+ €199 setup iniziale</p>
                  </div>
                </div>
                <ul class="list-unstyled">
                  <li class="mb-2">✓ Gestione parco auto</li>
                  <li class="mb-2">✓ Modulo officina</li>
                  <li class="mb-2">✓ {{ isBasePlan ? '50' : '75' }} utenti inclusi</li>
                  <li class="mb-2">✓ Veicoli illimitati</li>
                  <li class="mb-2">✓ Supporto tecnico</li>
                  <li class="mb-2">✓ Manutenzione €249/anno dal 2° anno</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Immobiliare FVG -->
          <div class="col-md-4">
            <div class="card h-100 shadow-sm">
              <div class="card-body">
                <div class="text-center mb-4">
                  <div class="feature-icon bg-primary bg-gradient mb-3">
                    <i class="bi bi-house fs-2"></i>
                  </div>
                  <h2 class="card-title">Immobiliare FVG</h2>
                  <p class="text-muted">1 Azienda</p>
                  <div class="pricing mt-3">
                    <h3 class="display-6 fw-bold">
                      {{ getPriceDisplay('immobiliare') }}
                    </h3>
                    <p class="text-muted">+ €199 setup iniziale</p>
                  </div>
                </div>
                <ul class="list-unstyled">
                  <li class="mb-2">✓ Gestione immobili</li>
                  <li class="mb-2">✓ Portale annunci</li>
                  <li class="mb-2">✓ {{ isBasePlan ? '50' : '75' }} utenti inclusi</li>
                  <li class="mb-2">✓ Immobili illimitati</li>
                  <li class="mb-2">✓ Supporto tecnico</li>
                  <li class="mb-2">✓ Manutenzione €249/anno dal 2° anno</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Completo FVG -->
          <div class="col-md-4">
            <div class="card h-100 shadow-sm border-primary">
              <div class="card-body">
                <div class="text-center mb-4">
                  <div class="feature-icon bg-primary bg-gradient mb-3">
                    <i class="bi bi-stars fs-2"></i>
                  </div>
                  <h2 class="card-title">Completo FVG</h2>
                  <p class="text-muted">2 Aziende</p>
                  <span class="badge bg-primary mb-2">Più popolare</span>
                  <div class="pricing mt-3">
                    <h3 class="display-6 fw-bold">
                      {{ getPriceDisplay('completo') }}
                    </h3>
                    <p class="text-muted">+ €299 setup iniziale</p>
                  </div>
                </div>
                <ul class="list-unstyled">
                  <li class="mb-2">✓ Gestione auto completa</li>
                  <li class="mb-2">✓ Gestione immobiliare completa</li>
                  <li class="mb-2">✓ {{ isBasePlan ? '50' : '75' }} utenti inclusi</li>
                  <li class="mb-2">✓ Auto e immobili illimitati</li>
                  <li class="mb-2">✓ Supporto tecnico prioritario</li>
                  <li class="mb-2">✓ Formazione base inclusa</li>
                  <li class="mb-2">✓ Manutenzione €249/anno dal 2° anno</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Promo Banner -->
        <div class="promo-banner mt-5 p-4 bg-primary text-white rounded-3">
          <div class="row align-items-center">
            <div class="col-md-8">
              <h3 class="mb-2">🚀 Offerta di Lancio</h3>
              <p class="lead mb-0">
                Approfitta dello sconto del 30% per i primi 3 mesi + Setup Gratuito
              </p>
            </div>
            <div class="col-md-4 text-md-end mt-3 mt-md-0">
              <button
                class="btn btn-light btn-lg"
                data-bs-toggle="modal"
                data-bs-target="#promoModal"
              >
                Scopri di più
              </button>
            </div>
          </div>
        </div>

        <!-- Modal per l'offerta di lancio -->
        <div
          class="modal fade"
          id="promoModal"
          tabindex="-1"
          aria-labelledby="promoModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="promoModalLabel">🚀 Dettagli Offerta di Lancio</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <h4 class="mb-4">Approfitta di questi vantaggi esclusivi:</h4>
                <div class="row g-4">
                  <div class="col-md-6">
                    <div class="card h-100">
                      <div class="card-body">
                        <h5 class="card-title">💰 Sconto del 30%</h5>
                        <p class="card-text">
                          Per i primi 3 mesi di abbonamento, risparmia il 30% sul canone mensile:
                        </p>
                        <ul class="list-unstyled">
                          <li>Auto FVG: da €49 a €34,30/mese</li>
                          <li>Immobiliare FVG: da €49 a €34,30/mese</li>
                          <li>Completo FVG: da €89 a €62,30/mese</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card h-100">
                      <div class="card-body">
                        <h5 class="card-title">🎁 Setup Gratuito</h5>
                        <p class="card-text">
                          Risparmia completamente il costo di setup iniziale:
                        </p>
                        <ul class="list-unstyled">
                          <li>Auto FVG: risparmio di €199</li>
                          <li>Immobiliare FVG: risparmio di €199</li>
                          <li>Completo FVG: risparmio di €299</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="alert alert-info mt-4">
                  <h5>⏰ Offerta a tempo limitato</h5>
                  <p class="mb-0">
                    Questa promozione è valida per un periodo limitato. Contattaci subito per maggiori informazioni e per attivare il tuo software.
                  </p>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="goToContact"
                  data-bs-dismiss="modal"
                >
                  Contattaci
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Note Importanti -->
    <section class="pricing-notes py-5 bg-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h4 class="text-center mb-4">Note Importanti</h4>
            <div class="row g-4">
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">Abbonamento Mensile</h5>
                    <ul class="list-unstyled mb-0">
                      <li class="mb-2">✓ Nessun vincolo lungo termine</li>
                      <li class="mb-2">✓ Aggiornamenti inclusi</li>
                      <li class="mb-2">✓ Supporto tecnico incluso</li>
                      <li>✓ Pagamento mensile</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">Licenza Perpetua</h5>
                    <ul class="list-unstyled mb-0">
                      <li class="mb-2">✓ Pagamento una tantum</li>
                      <li class="mb-2">✓ 12 mesi manutenzione inclusa</li>
                      <li class="mb-2">✓ €249/anno dal secondo anno</li>
                      <li>✓ Supporto tecnico incluso</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Sezione Preventivatore -->
    <section class="calculator-section mt-5 p-4 bg-light rounded">
      <h3 class="mb-4 text-center">Calcola il tuo Preventivo</h3>

      <div class="row">
        <div class="col-md-6">
          <!-- Form Preventivo -->
          <div class="card">
            <div class="card-body">
              <div class="mb-3">
                <label class="form-label">Tipo di Software</label>
                <select v-model="calculator.type" class="form-select">
                  <option value="auto">Auto FVG</option>
                  <option value="immobiliare">Immobiliare FVG</option>
                  <option value="completo">Completo FVG</option>
                </select>
              </div>

              <div class="mb-3">
                <label class="form-label">Modalità di Acquisto</label>
                <select v-model="calculator.purchaseType" class="form-select">
                  <option value="subscription">Abbonamento Mensile</option>
                  <option value="perpetual">Licenza Perpetua</option>
                </select>
              </div>

              <div class="mb-3">
                <label class="form-label">Piano Utenti</label>
                <select v-model="calculator.userPlan" class="form-select">
                  <option value="base">Base (fino a 50 utenti)</option>
                  <option value="extended">Esteso (fino a 75 utenti)</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <!-- Risultato Preventivo -->
          <div class="card bg-primary text-white">
            <div class="card-body">
              <h4 class="card-title mb-4">Riepilogo Preventivo</h4>

              <div class="d-flex justify-content-between mb-2">
                <span>Software:</span>
                <strong>{{ getSoftwareType }}</strong>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <span>Tipo Licenza:</span>
                <strong>{{ getLicenseType }}</strong>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <span>Piano Utenti:</span>
                <strong>{{ getUserPlan }}</strong>
              </div>

              <hr class="border-white opacity-25">

              <div class="d-flex justify-content-between mb-2">
                <span>Setup Iniziale:</span>
                <strong>€{{ setupCost }}</strong>
              </div>

              <div class="d-flex justify-content-between mb-2" v-if="calculator.purchaseType === 'subscription'">
                <span>Canone Mensile:</span>
                <strong>€{{ monthlyFee }}/mese</strong>
              </div>

              <div class="d-flex justify-content-between mb-2" v-if="calculator.purchaseType === 'perpetual'">
                <span>Licenza Perpetua:</span>
                <strong>€{{ perpetualCost }}</strong>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <span>Manutenzione Annuale (dal 2° anno):</span>
                <strong>€249/anno</strong>
              </div>

              <hr class="border-white opacity-25">

              <div class="d-flex justify-content-between mb-2">
                <h5 class="mb-0">Totale Primo Anno:</h5>
                <h5 class="mb-0">€{{ totalFirstYear }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PricingView',
  data() {
    return {
      isSubscription: true,
      isBasePlan: true,
      calculator: {
        type: 'auto',
        purchaseType: 'subscription',
        userPlan: 'base'
      }
    }
  },
  methods: {
    goToContact() {
      this.$router.push('/contatti')
    }
  },
  computed: {
    getPriceDisplay() {
      return (type) => {
        const prices = {
          auto: {
            subscription: { base: 49, extended: 99 },
            perpetual: { base: 1499, extended: 1999 }
          },
          immobiliare: {
            subscription: { base: 49, extended: 99 },
            perpetual: { base: 1499, extended: 1999 }
          },
          completo: {
            subscription: { base: 89, extended: 149 },
            perpetual: { base: 2499, extended: 2999 }
          }
        }

        const licenseType = this.isSubscription ? 'subscription' : 'perpetual'
        const planType = this.isBasePlan ? 'base' : 'extended'
        const price = prices[type][licenseType][planType]

        return `€${price}${this.isSubscription ? '/mese' : ''}`
      }
    },
    getSoftwareType() {
      const types = {
        auto: 'Auto FVG',
        immobiliare: 'Immobiliare FVG',
        completo: 'Completo FVG'
      }
      return types[this.calculator.type]
    },
    getLicenseType() {
      return this.calculator.purchaseType === 'subscription'
        ? 'Abbonamento Mensile'
        : 'Licenza Perpetua'
    },
    getUserPlan() {
      return this.calculator.userPlan === 'base'
        ? 'Base (50 utenti)'
        : 'Esteso (75 utenti)'
    },
    setupCost() {
      return this.calculator.type === 'completo' ? 299 : 199
    },
    monthlyFee() {
      const basePrices = {
        auto: { base: 49, extended: 99 },
        immobiliare: { base: 49, extended: 99 },
        completo: { base: 89, extended: 149 }
      }
      return basePrices[this.calculator.type][this.calculator.userPlan]
    },
    perpetualCost() {
      const perpetualPrices = {
        auto: { base: 1499, extended: 1999 },
        immobiliare: { base: 1499, extended: 1999 },
        completo: { base: 2499, extended: 2999 }
      }
      return perpetualPrices[this.calculator.type][this.calculator.userPlan]
    },
    totalFirstYear() {
      if (this.calculator.purchaseType === 'subscription') {
        return this.setupCost + (this.monthlyFee * 12)
      } else {
        return this.setupCost + this.perpetualCost
      }
    }
  }
}
</script>

<style scoped>
.feature-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.pricing-hero {
  background: #219ebc !important;
}

.card {
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-5px);
}

.py-6 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.btn-primary {
  background: #219ebc !important;
  border-color: #219ebc !important;
}

.btn-primary:hover {
  background: #023047 !important;
  border-color: #023047 !important;
}

.btn-outline-primary {
  color: #219ebc !important;
  border-color: #219ebc !important;
}

.btn-outline-primary:hover {
  background: #219ebc !important;
  color: #fff !important;
}

.feature-icon {
  background: #219ebc !important;
  color: #fff !important;
}

.card {
  border-color: #8ecae6 !important;
}

.card.border-primary {
  border-color: #219ebc !important;
}

.badge.bg-primary {
  background: #219ebc !important;
}

.promo-banner {
  background: #219ebc !important;
}

.btn-light {
  background: #ffb703 !important;
  color: #023047 !important;
}

.btn-light:hover {
  background: #fb8500 !important;
}

.modal-header.bg-primary {
  background: #219ebc !important;
}

.calculator-section {
  background: rgba(142, 202, 230, 0.1) !important;
}

.card.bg-primary {
  background: #219ebc !important;
}
</style>
